import React from 'react';
import PropTypes from 'prop-types';

function NavDropdownLinkItem({ name, to }) {
	return (
		<li>
			<a
				href={to}
				className="block px-4 py-2 text-sm text-[--color-text-secondary] hover:bg-[--color-bg-secondary] hover:text-[--color-text-primary] transition-colors"
				target="_blank"
				rel="noreferrer"
			>
				{name}
			</a>
		</li>
	);
}

NavDropdownLinkItem.propTypes = {
	name: PropTypes.string.isRequired,
	to: PropTypes.string.isRequired,
};

export default NavDropdownLinkItem;
